import { useTranslation } from 'react-i18next'
import { useFormikContext } from 'formik'

import { useScreen } from '../../../../../hooks'
import { FormFieldSelectNG } from '../../../../Form'
import { FormikField, getFormikFormFieldErrorProps } from '../../../../Formik'
import { UserSelect } from '../../../../User'
import { getTaskManagers } from '../../../Task.api'
import {
  TASK_FORM_MANAGER_FIELD_NAME,
  TASK_FORM_SERVICE_REQUEST_FIELD_NAME,
} from '../../TaskForm.constants'

import { getManagerFieldApiParams } from './ManagerField.utils'

function ManagerField({ isEmptyServiceRequest, isLoading, ...restProps }) {
  const { t } = useTranslation()

  const { values } = useFormikContext()

  const { isMobileScreenSize } = useScreen() // TODO make same by css media instead of useScreen

  const apiParams = getManagerFieldApiParams(
    values[TASK_FORM_SERVICE_REQUEST_FIELD_NAME]
  )

  return (
    <FormikField
      {...restProps}
      Component={FormFieldSelectNG}
      Select={UserSelect}
      apiParams={apiParams}
      controlProps={{
        borderless: !isMobileScreenSize,
        contentProps: {
          inputProps: {
            placeholder: t('Task.FormManagerFieldPlaceholderKey'),
          },
        },
      }}
      disabled={isEmptyServiceRequest}
      fieldComponentProps={{
        isLoading,
        label: `${t('Task.FormManagerFieldLabelKey')}:`,
        required: true,
        shouldAdaptToMobileScreen: true,
      }}
      getData={getTaskManagers}
      getErrorProps={getFormikFormFieldErrorProps}
      name={TASK_FORM_MANAGER_FIELD_NAME}
      tooltip={
        isEmptyServiceRequest
          ? t('Task.FormManagerFieldRequestNotSelectedTooltipKey')
          : null
      }
    />
  )
}

export default ManagerField
